import React, { useEffect } from 'react';
import favicon from './favicon.png';
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
// Components
import Header from "./components/Header";
import Footer from "./components/Footer";
// import DiscussForm from "./components/DiscussForm.js";
import Home from "./pages/Home"; // Create individual pages for each section
import LandownerShare from "./pages/LandownerShare";
import About from "./pages/About";
import Location from "./pages/Location";
import Projects from "./pages/Projects.js";
import ContactUs from "./pages/ContactUs";
import FacilityManagement from './pages/FacilityManagement.js';
// Location Pages
import Hyderabad from './pages/Locations/Hyderabad.js';
import Banglore from './pages/Locations/Banglore.js';
import Dubai from './pages/Locations/Dubai.js';
import Mumbai from './pages/Locations/Mumbai.js';
import Pune from './pages/Locations/Pune.js';
import DelhiNCR from './pages/Locations/DelhiNCR.js';
// Project Categories
import Flats from './pages/Projects/Flats.js';
import Villas from './pages/Projects/Villas.js';
import Plots from './pages/Projects/Plots.js';
import Commercials from './pages/Projects/Commercials.js';
// Project Pages
import ASBLSpire from './pages/ASBLSpire.js'
import ASBLSpectra from './pages/ASBLSpectra.js'
import IRIS from './pages/IRISByRaghava.js'
import Wave from './pages/WaveByRaghava.js'
import Pearl from './pages/PearlByAuroReality.js'
import Rajpushpa from './pages/RajpushpaPristinia.js'
import MyHome from './pages/MyHomeApas.js'
import UpcomingLuxury from './pages/UpcomingLuxury.js'
import Candeur from './pages/CandeurLandscape.js'
import Luxury from './pages/LuxuryApartments.js'
import Azizi from './pages/AziziVenice.js'
import Reportage from './pages/ReportedVillage.js'
import Damac from './pages/DamacLagoons.js'
import PrivacyPolicy from './pages/PrivacyPolicy.js';
import TermsAndConditions from './pages/TermsAndConditions.js';
import ProjectDetails from './pages/ProjectDetails'; // or wherever you saved the file
import WhatsAppButton from './components/WhatsAppButton.js';

// hyd projects
import Trilight from './pages/Trilight.js';


function App() {
  window.addEventListener('load', () => {
    window.scrollTo(0, 0); // Scroll to the top-left corner
  });

  useEffect(() => {
    window.scrollTo(0, 0); // Scroll to top on page load
  }, []);

  useEffect(() => {
    const link = document.createElement('link');
    link.rel = 'icon';
    link.href = favicon;
    document.head.appendChild(link);
  }, []);

  return (
    <Router>
      <Header />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/landowner-share" element={<LandownerShare />} />
        <Route path="/about" element={<About />} />
        <Route path="/locations" element={<Location />} />
        <Route path="/facility-management" element={<FacilityManagement />} />

        {/* Location Pages */}
        <Route path="/hyderabad" element={<Hyderabad />} />
        <Route path="/dubai" element={<Dubai />} />
        <Route path="/banglore" element={<Banglore />} />
        <Route path="/mumbai" element={<Mumbai />} />
        <Route path="/pune" element={<Pune />} />
        <Route path="/delhiNCR" element={<DelhiNCR />} />
        {/* Location Pages */}
        {/* Project Categories */}
        <Route path="/projects/flats" element={<Flats />} />
        <Route path="/projects/villas" element={<Villas />} />
        <Route path="/projects/plots" element={<Plots />} />
        <Route path="/projects/commercials" element={<Commercials />} />
        {/* <Route path="/projects/:category" element={<ProjectCategoryPage />} /> */}
        <Route path="/projects/:id" element={<ProjectDetails />} />


        {/* Project Categories */}
        {/* <Route path="/projects" element={<Project />} /> */}
        <Route path="/contact-us" element={<ContactUs />} />
        {/* <Route path="/location-hyderabad" element={<Hyderabad />} />
        <Route path="/location-dubai" element={<Dubai />} />
        <Route path="/location-banglore" element={<Banglore />} /> */}
        <Route path="/project-asbl-spire" element={<ASBLSpire />} />
        <Route path="/project-asbl-spectra" element={<ASBLSpectra />} />
        <Route path="/project-iris" element={<IRIS />} />
        <Route path="/project-wave" element={<Wave />} />
        <Route path="/project-pearl" element={<Pearl />} />
        <Route path="/project-rajpushpa" element={<Rajpushpa />} />
        <Route path="/project-my-home" element={<MyHome />} />
        <Route path="/project-upcoming" element={<UpcomingLuxury />} />
        <Route path="/project-candeur" element={<Candeur />} />
        <Route path="/project-luxury" element={<Luxury />} />
        <Route path="/project-azizi" element={<Azizi />} />
        <Route path="/project-reportage" element={<Reportage />} />
        <Route path="/project-damac" element={<Damac />} />
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        <Route path="/terms-conditions" element={<TermsAndConditions />} />
        <Route path="/projects" element={<Projects />} />
        <Route path="/projects/:projectId" element={<ProjectDetails />} />
        <Route path="/projects/:projectId" element={<ProjectDetails />} />
        {/* Hyd projects */}
        <Route path="/trilight" element={<Trilight />} />
        {/* Hyd projects */}


      </Routes>
      {/* <WhatsAppButton /> */}
      <Footer />
    </Router>
  );
}

export default App;
